/**
 * Client-side mirror of the API's word count validation.
 * Must stay in sync with the API so imports can be rejected up front with
 * the same word totals the server would compute on save.
 *
 * @param {*} value String, object, array, or primitive to count words in
 * @param {string[]} exclude Property names to skip, matched at every nesting depth
 * @returns {number} Total word count
 */
export const countWords = (value, exclude = []) => {
  if (value === null || value === undefined) return 0;

  if (typeof value === 'string') {
    const plainText = value
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/g, ' ');

    return plainText.split(/\s+/).filter(Boolean).length;
  }

  if (Array.isArray(value)) {
    return value.reduce((count, item) => count + countWords(item, exclude), 0);
  }

  if (typeof value === 'object') {
    return Object.entries(value)
      .filter(([property]) => !exclude.includes(property))
      .reduce((count, [, item]) => count + countWords(item, exclude), 0);
  }

  return 0;
};
